export default "__VITE_ASSET__124fa9f7__"